var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaybar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 4096,
    height: 400,
    viewBox: "0 0 4096.0 400.0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document",
    transform: "scale(0.9971631768338249 0.9971631768338249) translate(2048.0 201.61159991875752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1955.22,-19.5522 L-551.372,-19.5522 C-559.193,-78.2089 -610.029,-121.224 -672.596,-121.224 C-731.253,-121.224 -782.089,-78.2089 -793.82,-19.5522 L-1955.22,-19.5522 L-1955.22,19.5522 L-793.82,19.5522 C-785.999,78.2089 -735.163,121.224 -672.596,121.224 C-613.94,121.224 -563.104,78.2089 -551.372,19.5522 L1955.22,19.5522 L1955.22,-19.5522 Z ",
    fill: "#deedf8",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaybar);
export default __webpack_public_path__ + "static/media/Play bar.a7c087fe742710dd2768dc9cea4adc39.svg";
export { ForwardRef as ReactComponent };